import React from 'react';
import { Form, Select } from 'antd';
import { selectInputFilterHelper } from '@common/services';
import { FormInstance } from 'antd/lib/form';

type OrganizationBusinessType = {
  id: string;
  name: string;
};

export function OrganizationBusinessSelect({
  disabled,
  organizationBusinesses,
  form,
}: {
  disabled: boolean;
  organizationBusinesses: OrganizationBusinessType[];
  form: FormInstance;
}) {
  return (
    <Form.Item
      label="Facility"
      name="organizationBusinessId"
      colon={false}
      rules={[{ required: true, message: 'Please select a facility' }]}
    >
      <Select
        disabled={disabled}
        size="large"
        showSearch
        filterOption={selectInputFilterHelper}
        placeholder="Select a facility..."
        getPopupContainer={(trigger) => trigger.parentNode}
        onChange={() => {
          form.setFieldsValue({ organizationUnitId: undefined });
        }}
      >
        {organizationBusinesses.map(({ id, name }) => {
          return (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
}
